import ApiConfig from "../Config";
import apiService from "../services/apiService";

const userService = {
  getAllUsers: (token) =>
    apiService.get(ApiConfig.getAllUser, {
      headers: { "x-access-token": token },
    }),
};
export default userService;
